"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rewards API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetGiveaways200ResponseDataToJSON = exports.GetGiveaways200ResponseDataFromJSONTyped = exports.GetGiveaways200ResponseDataFromJSON = exports.instanceOfGetGiveaways200ResponseData = void 0;
var Giveaway_1 = require("./Giveaway");
/**
 * Check if a given object implements the GetGiveaways200ResponseData interface.
 */
function instanceOfGetGiveaways200ResponseData(value) {
    var isInstance = true;
    isInstance = isInstance && "items" in value;
    isInstance = isInstance && "total" in value;
    return isInstance;
}
exports.instanceOfGetGiveaways200ResponseData = instanceOfGetGiveaways200ResponseData;
function GetGiveaways200ResponseDataFromJSON(json) {
    return GetGiveaways200ResponseDataFromJSONTyped(json, false);
}
exports.GetGiveaways200ResponseDataFromJSON = GetGiveaways200ResponseDataFromJSON;
function GetGiveaways200ResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'items': (json['items'].map(Giveaway_1.GiveawayFromJSON)),
        'total': json['total'],
    };
}
exports.GetGiveaways200ResponseDataFromJSONTyped = GetGiveaways200ResponseDataFromJSONTyped;
function GetGiveaways200ResponseDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'items': (value.items.map(Giveaway_1.GiveawayToJSON)),
        'total': value.total,
    };
}
exports.GetGiveaways200ResponseDataToJSON = GetGiveaways200ResponseDataToJSON;
